<template>
  <a :href="cardInfo.link" target="_blank" class="case-box1">
    <div class="category">{{cardInfo.category}}</div>
    <h1>{{ cardInfo.title }}</h1>
    <div class="video-box">
      <div class="play" @click="isActive=true"></div>
      <div class="img-wrap" :style="{'background-image': `url(${cardInfo.imgSrc})`}"></div>
    </div>
    <!-- modal 层 -->
    <!-- <modal @close="isActive=false" :isActive="isActive" v-if="isActive">
      <div slot="content" class="video-wrapper">
        <video :src="cardInfo.videoSrc" autoplay="autoplay" controls="controls" loop="loop" preload="auto"></video>
      </div>
    </modal> -->
  </a>
</template>

<script>
// import modal from '@/components/modal/modal'

export default {
  data () {
    return {
      isActive: false
    }
  },
  props: ['cardInfo'],
  components: {
    // modal
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/app.sass';

.case-box1 {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 31.3%;
  height: 298px;
  padding: 43px 21px 23px 21px;
  background: #fff;
  border-radius:5px;
  box-sizing: border-box;
  margin-bottom: 20px;
  margin-right: 30px;
  &:nth-of-type(3n) {
    margin-right: 0;
  }
  &:nth-last-of-type(1) {
    margin-bottom: 0;
  }
  &:nth-last-of-type(2) {
    margin-bottom: 0;
  }
  &:nth-last-of-type(3) {
    margin-bottom: 0;
  }
  @include tablet {
    width: calc(33.333% - 20px);
  }
  @include mobile {
    width: 90vw !important;
    height: 240px;
    padding: 36px 18px 24px 18px;
    margin-bottom: 13px;
    margin-right: 0;
    &:nth-last-of-type(1) {
      margin-bottom: 0;
    }
    &:nth-last-of-type(2) {
      margin-bottom: 13px;
    }
    &:nth-last-of-type(3) {
      margin-bottom: 13px;
    }
  }
  .category {
    position: absolute;
    top: 0;
    left: 21px;
    width: 79px;
    height: 22px;
    font-size: 12px;
    font-weight: 500;
    color: #fff;
    text-align: center;
    line-height: 22px;
    background: rgba(251,188,5,1);
    box-shadow: 0px 2px 5px 0px rgba(251,188,5,0.2);
    border-radius: 0px 0px 4px 4px;
    @include mobile {
      width: 76px;
      height: 21px;
      font-size: 12px;
      left: 20px;
    }
  }
  & h1 {
    color: $font-color1;
    font-size: $fontSize20;
    font-weight: 500;
    line-height: 27px;
    @include limit-line-numbers(2);
    @include mobile {
      font-size: 17px;
      line-height: 1.2;
    }
  }
  & .video-box {
    position: relative;
    // height: 160px;
    & .play {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 49px;
      height: 34px;
      background-image: url('../../image/game/play-white.png');
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
      cursor: pointer;
    }
    & .img-wrap {
      height: 160px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      @include mobile {
        height: 127px;
      }
    }
  }
}

.video-wrapper {
  video {
    width: 100%;
    height: 100%;
  }
}

@include mobile {
  .case-box1 {
    width: 100%;
    & .video-box {
      width: 100%;
    }
  }
}
</style>
